import React from "react";
import { DailyTip } from "@/features/daily/components/DailyTip";
import { FreshnessBadge } from "@/features/daily/components/FreshnessBadge";

type Props = {
    fetchedAt: number | null;
    sourceAsOf: number | null;
    stale: boolean;
    evidenceLabel: string | null;
    /** D131: the query's evidence, policy and cut, behind an (i) instead of a banner. */
    evidenceTip: string[] | null;
    note: string;
};

/**
 * FR-009: the page's freshness is always on screen — also on a wall display nobody
 * is touching — and "when this page asked" stays apart from "when the evidence was
 * produced".
 */
export const SourceBar: React.FC<Props> = ({ fetchedAt, sourceAsOf, stale, evidenceLabel, evidenceTip, note }) => (
    <footer className="daily-sourcebar" aria-label="Frescura y evidencia">
        <span className="daily-sourcebar__group">
            <FreshnessBadge fetchedAt={fetchedAt} sourceAsOf={sourceAsOf} stale={stale} />
            {evidenceTip === null ? null : <DailyTip id="daily-source-tip" label="Detalle de la evidencia" lines={evidenceTip} />}
            {evidenceLabel === null ? null : <span>{evidenceLabel}</span>}
        </span>
        <span>{note}</span>
    </footer>
);
